import { render, staticRenderFns } from "./new-password.vue?vue&type=template&id=336d7808&"
import script from "./new-password.vue?vue&type=script&lang=js&"
export * from "./new-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports